import TWEEN from '@tweenjs/tween.js';
import Bezier from '../helpers/Bezier';

export default function handleTween(time) {
  var _this = this;
  var twObj = { progress: 0 };
  new TWEEN.Tween(twObj)
    .to({ progress: 1 }, time) // time
    .easing(TWEEN.Easing.Linear.None)
    .onUpdate(function () {
      var p = Bezier(_this.p0, _this.c0, _this.c1, _this.p1, twObj.progress);
      _this.ball.x = p.x;
      _this.ball.y = p.y;
    })
    .onComplete(function () {
      _this.nextStep();
    })
    .start();
}
